import workspaceQuery from 'graphql/queries/sales/SalesOrderLineAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/common/AuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const SalesOrderLineAuditByField = {
  type: 'AuditChange',
  formTitle: 'Sales Order Line Audit',
  formUrl: '/Sales/SalesOrderLineAudit/Form/',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Sales',
  screenReference: 'SALES', //There's no direct approach to this screen (You get there via lines/right-click), so just link to sales as permission.
  operations: ALLOW_VIEW,
};

export default SalesOrderLineAuditByField;
